module.exports = __webpack_public_path__ + "static/salon-pasajeros---asientos-225a3417371648650fa45639cb29628a.jpg";